import { render, staticRenderFns } from "./VIPset.vue?vue&type=template&id=6e860366&scoped=true"
import script from "./VIPset.vue?vue&type=script&lang=js"
export * from "./VIPset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e860366",
  null
  
)

export default component.exports